import { useEffect, useState } from "react"

export type ButtonProps = {
  options: {
    class?: string
    cb?(): void
    disabled?: boolean
    text: string
  }
  style?: React.CSSProperties
  type?: 'timeout' | 'default'
  //type timeout生效
  defaultTimeout?: number
}
function Button(props: ButtonProps) {
  const { options } = props;
  let classArr = ["rounded-full text-white font-bold"];

  if (options.class) {
    classArr.push(options.class);
  } else {
    classArr.push("bg-buttonDefaultBgColor");
  }

  function onClick() {
    if (options.cb) {
      options.cb();
    }
  }


  const [count, setCount] = useState(props.defaultTimeout || 600);


  useEffect(() => {
    if (props.type !== 'timeout') return;

    const interval = setInterval(() => {
      setCount(prevCount => {
        if (prevCount <= 1) {
          clearInterval(interval);
          onClick()
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [props.type]);



  return (
    <button
      type="button"
      className={classArr.join(" ")}
      onClick={onClick}
      style={{
        opacity: options.disabled ? 0.5 : 1,
        fontSize: 30,
        height: 50,
        padding: '0px 20px',
        ...props.style || {}
      }}
      disabled={options.disabled}
    >
      <span
        style={{
          whiteSpace: 'nowrap', // 不换行
        }}
      >{options.text}</span>

      {props.type === 'timeout' && (
        <span
          style={{
            fontWeight: 400,
          }}
        >{`（${count}）`}</span>
      )}
    </button>
  );
}

export default Button;
